import { z } from "zod";

export const appleOAuthCallbackSchema = z.object({
	id_token: z.string(),
	first_name: z.string().optional(),
	last_name: z.string().optional(),
});

export type AppleOAuthCallbackPayload = z.infer<typeof appleOAuthCallbackSchema>;
